import { BaseSpriteInterface } from "../SpriteInterfaces";

export interface InventoryData extends BaseSpriteInterface{
  count: any;
  itemName: string;
  animationKey: string;
  scene: any;
}

export class InventorySlot {
  background: Phaser.GameObjects.Graphics;
  item: Phaser.GameObjects.Sprite;
  quantityText: Phaser.GameObjects.Text;
  x: number;
  y: number;
  count: integer;
  static _tileSize: integer;
  static uiScale: number;
  static graphics: Phaser.GameObjects.Graphics;
  static squareWidth: number;

  constructor(data: InventoryData) {
    let { scene, x, y, count, itemName, texture, animationKey} = data;
    this.x = x;
    this.y = y;
    this.count = count;
    let graphics = scene.add.graphics();
    graphics.fillStyle(0x808080, 0.5);
    this.background = graphics.fillRoundedRect(
      x - InventorySlot.squareWidth / 2,
      y - InventorySlot.squareWidth / 2,
      InventorySlot.squareWidth,
      InventorySlot.squareWidth,
      6
    );

    this.quantityText = scene.add
      .text(x, y + InventorySlot._tileSize / 3, count, {
        font: '11px Courier',
        color: '#111',
      })
      .setOrigin(0.5, 0);

    scene.add.graphics(this.background);

    this.item = scene.add.sprite(
      x,
      y - InventorySlot._tileSize / 12,
      texture,
      itemName === 'heart' || itemName === 'cookie' ? null : itemName
    );

    if(animationKey){
      this.item.anims.play(animationKey, true);
    }
  }

  static setupGraphics(_tileSize: number, uiScale: number) {
    InventorySlot._tileSize = _tileSize;
    InventorySlot.uiScale = uiScale;
    InventorySlot.squareWidth = InventorySlot._tileSize * InventorySlot.uiScale;
  }

  destroy() {
    if (this.background) this.background.clear();
    if (this.background) this.background.destroy();
    if (this.item) this.item.destroy();
    if (this.quantityText) this.quantityText.destroy();
  }
}
